import React, { useState } from "react";
import SEO from "../component/SEO";
import { BsCloudUpload } from "react-icons/bs";
import { ImagetoBase64 } from "../utility/ImagetoBase64";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
const Newproduct = () => {
  const [data, setData] = useState({
    name: "",
    category: "other",
    image: "",
    price: "",
    description: "",
    options: [], // new: steps array
  });
  const token = useSelector((state) => state.user.token);
  const productList = useSelector((state) => state.product.productList);
  const categoryList = useSelector((state) => state.product.categoryList); // <--- Add this
  const [editMode, setEditMode] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState("");

  const handleProductSelect = (e) => {
    const productId = e.target.value;
    if (!productId) {
      setEditMode(false);
      setSelectedProductId("");
      setData({
        name: "",
        category: "other",
        image: "",
        price: "",
        description: "",
        options: [],
      });
      return;
    }

    const product = productList.find((p) => p._id === productId);
    if (product) {
      setEditMode(true);
      setSelectedProductId(productId);
      setData({
        name: product.name,
        category: product.category,
        image: product.image,
        price: product.price,
        description: product.description,
        options: product.options || [],
      });
    }
  };
  // simple handlers
  const handleOnchange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const uploadImage = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const imgData = await ImagetoBase64(file);
    setData((prev) => ({ ...prev, image: imgData }));
  };

  // Add a new option step
  const addOptionStep = () => {
    setData((prev) => ({
      ...prev,
      options: [
        ...prev.options,
        { title: "New Step", multiple: false, required: false, choices: [] },
      ],
    }));
  };

  // Remove step
  const removeStep = (index) => {
    setData((prev) => {
      const options = [...prev.options];
      options.splice(index, 1);
      return { ...prev, options };
    });
  };

  // Update step title / flags
  const updateStep = (index, key, value) => {
    setData((prev) => {
      const options = [...prev.options];
      options[index] = { ...options[index], [key]: value };
      return { ...prev, options };
    });
  };

  // Add a choice to a step
  const addChoice = (stepIndex) => {
    setData((prev) => {
      const options = [...prev.options];
      options[stepIndex].choices.push({
        id: `choice_${Date.now()}`,
        name: "New choice",
        price: 0,
        default: false,
      });
      return { ...prev, options };
    });
  };

  // Update choice
  const updateChoice = (stepIndex, choiceIndex, key, value) => {
    setData((prev) => {
      const options = [...prev.options];
      const choice = { ...options[stepIndex].choices[choiceIndex], [key]: key === "price" ? Number(value) : value };
      options[stepIndex].choices[choiceIndex] = choice;
      return { ...prev, options };
    });
  };

  const removeChoice = (stepIndex, choiceIndex) => {
    setData((prev) => {
      const options = [...prev.options];
      options[stepIndex].choices.splice(choiceIndex, 1);
      return { ...prev, options };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, image, category, price } = data;
    // basic validation
    if (!name || !image || !category || price === "" || price === undefined) {
      return toast.error("Please enter required fields");
    }
    if (!token) return toast.error("You are not logged in");
    // ensure price is number
    const payload = {
      ...data,
      price: Number(data.price),
    };

    try {
      const url = editMode 
        ? `${process.env.REACT_APP_SERVER_DOMIN}/updateProduct`
        : `${process.env.REACT_APP_SERVER_DOMIN}/uploadProduct`;

      const method = editMode ? "PUT" : "POST";

      const bodyPayload = editMode ? { ...payload, _id: selectedProductId } : payload;

      const res = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // ✅ send token from Redux
        },
        body: JSON.stringify(bodyPayload),
      });

      const json = await res.json();
      
      if (res.ok) {
        toast.success(json.message || "Success");
        setData({
          name: "",
          category: "other",
          image: "",
          price: "",
          description: "",
          options: [],
        });
        setEditMode(false);
        setSelectedProductId("");
      } else {
        toast.error(json.message || "Failed");
      }
    } catch (err) {
      console.error(err);
      toast.error("Operation failed");
    }
  };

  return (
    <div className="p-5">
      <SEO title="New Product - Admin K Bakery" description="Add a new product to K Bakery menu." />
      <SEO title="New Product - Admin K Bakery" description="Add a new product to K Bakery menu." />
      <h1 className="text-2xl font-bold text-center mb-4">{editMode ? "Edit Product" : "Add New Product"}</h1>

      <div className="max-w-2xl m-auto mb-4 bg-white p-4 shadow rounded">
        <label className="font-semibold block mb-2">Select Product to Edit (Optional)</label>
        <select 
          className="w-full p-2 border rounded bg-gray-50 focus:outline-none focus:ring-2 focus:ring-purple-400"
          onChange={handleProductSelect}
          value={selectedProductId}
        >
          <option value="">-- Create New Product --</option>
          {productList.map((p) => (
            <option key={p._id} value={p._id}>{p.name} ({p.category})</option>
          ))}
        </select>
      </div>

      <form className="m-auto w-full max-w-2xl shadow flex flex-col p-4 bg-white" onSubmit={handleSubmit}>
        <label>Name</label>
        <input type="text" name="name" className="bg-purple-100 p-1 my-1 rounded" onChange={handleOnchange} value={data.name} />

        <label htmlFor="category" className="block font-medium text-gray-700">
          Category
        </label>
        <select
          id="category"
          name="category"
          className="bg-purple-100 p-2 my-2 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-400"
          value={data.category}
          onChange={handleOnchange}
        >
          <option value="">Select Category</option>
          {categoryList && categoryList.length > 0 ? (
            categoryList.map((c) => (
              <option key={c._id || c.value} value={c.value}>
                {c.name}
              </option>
            ))
          ) : (
            <option value="other">Other</option>
          )}
        </select>


        <label htmlFor='image' className='my-1 cursor-pointer'>Image
        <div className='h-40 w-full bg-purple-100 rounded flex items-center justify-center'>
          {
            data.image ? <img src={data.image} className='h-full' alt="Product preview"/>: <span className='text-5xl'><BsCloudUpload/></span>
          }
       
        <input type={'file'} accept="image/*" id="image" onChange={uploadImage} className='hidden'/>
        </div>
        </label>


        <label>Price (base)</label>
        <input type="number" step="0.01" name="price" className="bg-purple-100 p-1 rounded" onChange={handleOnchange} value={data.price} />

        <label>Description</label>
        <textarea rows={2} name="description" value={data.description} className="bg-purple-100 p-1 resize-none rounded" onChange={handleOnchange} />

        <div className="mt-4">
          <div className="flex justify-between items-center">
            <h4 className="font-semibold">Add-on Steps (optional)</h4>
            <button type="button" onClick={addOptionStep} className="bg-blue-500 text-white px-3 py-1 rounded">Add Step</button>
          </div>

          {data.options.map((step, si) => (
            <div key={si} className="border rounded p-3 mt-3 bg-gray-50">
              <div className="flex justify-between items-center mb-2">
                <input className="p-1 border rounded" value={step.title} onChange={(e) => updateStep(si, "title", e.target.value)} />
                <div className="flex gap-2">
                  <label className="flex items-center gap-1"><input type="checkbox" checked={step.multiple} onChange={(e) => updateStep(si, "multiple", e.target.checked)} />Multiple</label>
                  <label className="flex items-center gap-1"><input type="checkbox" checked={step.required} onChange={(e) => updateStep(si, "required", e.target.checked)} />Required</label>
                  <button type="button" onClick={() => removeStep(si)} className="text-red-500">Remove</button>
                </div>
              </div>

              <div>
                <h5 className="font-medium">Choices</h5>
                {step.choices.map((ch, ci) => (
                  <div key={ci} className="flex gap-2 items-center mt-2">
                    <input value={ch.name} onChange={(e) => updateChoice(si, ci, "name", e.target.value)} className="p-1 border rounded" />
                    <input type="number" step="0.01" value={ch.price} onChange={(e) => updateChoice(si, ci, "price", e.target.value)} className="p-1 border rounded w-24" />
                    <label className="flex items-center gap-1"><input type="checkbox" checked={ch.default} onChange={(e) => updateChoice(si, ci, "default", e.target.checked)} />Default</label>
                    <button type="button" onClick={() => removeChoice(si, ci)} className="text-red-500">x</button>
                  </div>
                ))}
                <div className="mt-2">
                  <button type="button" onClick={() => addChoice(si)} className="bg-green-500 text-white px-2 py-1 rounded">Add Choice</button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <button type="submit" className="my-3 bg-green-400 hover:bg-green-600 text-white text-lg font-medium drop-shadow rounded-full py-2">
          {editMode ? "Update Product" : "Save Product"}
        </button>
      </form>
    </div>
  );
};

export default Newproduct;
